var style = {"container":"Requirement-module_container__3g0Vn","met":"Requirement-module_met__9klVd"};

export { style as default };
//# sourceMappingURL=Requirement.module.scss.js.map
